// this utility converts EPOCH timestamp in format DD-Mmm-YYYY HH-MM

export const FormatTimeStamp = (timeStamp) => {
    if (timeStamp) {
        return {
            date: getDate(timeStamp),
            time: getTime(timeStamp),
            timedate: getDate(timeStamp) + " " + getTime(timeStamp),
            timedateToLocale: getDateToLocale(timeStamp) + " " + getTimeToLocale(timeStamp),
            dateLocal :  getDateToLocale(timeStamp),
            timeLocal : getTimeToLocale(timeStamp),

        }
    }
    else {
        return {
            date: "",
            time: "",
            timedate: "",
            timedateToLocale:"",
            dateLocal : '',
            timeLocal : ''
        }
    }
};

function getDate(timeStamp) {
    let date = new Date(parseInt(timeStamp)).toGMTString();
  //  console.log('FTC', date);
    // let gmtDate = new Date(parseInt(timeStamp)).toGMTString();
    // console.log('FTC GMT', gmtDate);
    

    // let day = date.split(' ')[2];
    // let month = date.split(' ')[1];

    let day = date.split(' ')[1];
    let month = date.split(' ')[2];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
}

function getTime(timeStamp) {
    return new Date(parseInt(timeStamp)).toGMTString().split(' ')[4].substring(0, 5);
}
function getDateToLocale(timeStamp) {
    let date = new Date(parseInt(timeStamp)).toString();
   // console.log('get FTC1', date);
    // let gmtDate = new Date(parseInt(timeStamp)).toGMTString();
    // console.log('FTC GMT', gmtDate);
    

    // let day = date.split(' ')[2];
    // let month = date.split(' ')[1];

    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
   // console.log(`${day}-${month}-${year}`)
return `${day}-${month}-${year}`;
}

function getTimeToLocale(timeStamp) {
    return new Date(parseInt(timeStamp)).toString().split(' ')[4].substring(0, 5);
}
